module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Light-091661794a69e1f6b2b99d4f48fbf699.woff2";